<template>
  <div class="page flex-col">
    <div class="section_1 flex-col">
      <img
        class="image_1"
        referrerpolicy="no-referrer"
        src="../assets/header.png"
      />
      <router-link :to="{ name: 'view5', query: { robotId: this.robotId } }"
        ><button class="homeBtn">首页</button></router-link
      >
      <div class="text-wrapper_01 flex-row justify-between">
        <span class="text_01">{{ y1 }}</span>
        <span class="text_01">{{ y2 }}</span>
      </div>
      <div class="box_2 flex-row justify-between">
        <router-link :to="{ name: 'view7', query: { robotId: this.robotId } }">
          <div class="block_1 flex-col">
            <div class="block_2 flex-col">
              <span class="text_5">机器人录像查看</span>
              <img
                class="thumbnail_1"
                referrerpolicy="no-referrer"
                src="https://lanhu.oss-cn-beijing.aliyuncs.com/ps2fdg7bzv9yj6c0jf419olb4ejbrjr5rnocf4a9911-8ccf-4c67-8f76-2b8d57c1446d"
              />
              <img
                class="thumbnail_2"
                referrerpolicy="no-referrer"
                src="https://lanhu.oss-cn-beijing.aliyuncs.com/ps6d8pihqdlg44hr7a14qnosp6mh518qtfn8ba8f120-6883-4d43-8aa2-6e32dc357c92"
              />
              <img
                class="thumbnail_3"
                referrerpolicy="no-referrer"
                src="https://lanhu.oss-cn-beijing.aliyuncs.com/ps0oqnhtg59pvcvtrz2b6dw9z4cs2nqv4jld3cebf86-28bf-45c6-90a0-69695793a6d5"
              />
              <img
                class="thumbnail_4"
                referrerpolicy="no-referrer"
                src="https://lanhu.oss-cn-beijing.aliyuncs.com/psgs5ma1eutjstkeaio0xbptkczclqpvdccd189e5-7951-4079-865f-5e091edf4a34"
              />
            </div>
          </div>
        </router-link>

        <div class="block_3 flex-col">
          <router-link :to="{ name: 'view9', query: { robotId: this.robotId } }">
            <div class="box_3 flex-col">
              <span class="text_6">查看场内固定摄像头</span>
              <img
                class="thumbnail_5"
                referrerpolicy="no-referrer"
                src="https://lanhu.oss-cn-beijing.aliyuncs.com/psfdim7ibhoflpp6535c9o3ajntux0glrcfb985f263-e0e5-4f67-b428-c7db8b7f7c46"
              />
              <img
                class="thumbnail_6"
                referrerpolicy="no-referrer"
                src="https://lanhu.oss-cn-beijing.aliyuncs.com/psa86rvslb80qz6qcgno832yp1s0vg1arl4dc99c4d-5d13-499c-9859-00e9b8aff825"
              />
              <img
                class="thumbnail_7"
                referrerpolicy="no-referrer"
                src="https://lanhu.oss-cn-beijing.aliyuncs.com/pstp33ad3tqyn0uik8eeasbxbdtf6mzy7mbqf21ecf6e-ac93-4fdb-a9b8-fc82a904e94f"
              />
              <img
                class="thumbnail_8"
                referrerpolicy="no-referrer"
                src="https://lanhu.oss-cn-beijing.aliyuncs.com/pscolc29xxw1s8skvel9pvn30zoeynqcw0za76d3315-ae97-4cb5-a6d5-43ca0d50f4bf"
              />
            </div>
          </router-link>
        </div>
      </div>
      <div class="box_4 flex-row justify-between">
<!--        <video ref="videoElement" controls autoplay muted></video>-->
      </div>
      <div class="box_5 flex-row justify-between">
        <div class="group_5 flex-col">
          <div class="box_6 flex-row justify-between">
            <div class="image-wrapper_3 flex-col align-center">
              <img
                class="thumbnail_11"
                referrerpolicy="no-referrer"
                src="https://lanhu.oss-cn-beijing.aliyuncs.com/psowqs6u2h7qx04eq1mcdoffeupd7nbsv717dbd3a-843c-4e8c-b590-bea1ca0ca197"
              />
            </div>
            <span class="text_11">机器人所在位置</span>
          </div>
          <div class="box_7 flex-row justify-between">
            <span class="text_12">帧率切换</span>
            <!-- <div class="group_6 flex-row">
              <span class="text_13">低帧率</span>
              <img
                class="thumbnail_12"
                referrerpolicy="no-referrer"
                src="https://lanhu.oss-cn-beijing.aliyuncs.com/pslp3lay9ru6c56muf92mejgm5d5k4jh0oe63bd0fe-4800-4c62-a587-b53139bc0b51"
              />
            </div> -->
            <select
              class="gaodi"
              v-model="selectedOption"
              @change="handleSelectChange"
            >
              <option value="1">低帧率</option>
              <option value="2">高帧率</option>
            </select>
          </div>
        </div>
        <div class="group_7 flex-col">
          <div class="group_8 flex-row justify-between">
            <div class="image-wrapper_4 flex-col align-center">
              <img
                class="thumbnail_13"
                referrerpolicy="no-referrer"
                src="https://lanhu.oss-cn-beijing.aliyuncs.com/ps4so3mm188rgn2kkxvrbgsco1akm5ers78a5677b5-ef33-4193-8b88-362d866915c1"
              />
            </div>
            <span class="text_14">图灵楼下</span>
          </div>
          <div class="group_9 flex-row">
            <!-- <img
              class="label_1"
              referrerpolicy="no-referrer"
              src="https://lanhu.oss-cn-beijing.aliyuncs.com/psgcgbn8y713a86dpd456zqpom0uaumjanq87303293-e573-475b-bead-1b76aa0d37b0"
            />
            <div class="section_2 flex-row">
              <span class="text_15">2022-11-01&nbsp;&nbsp;10:00-11:00</span>
              <img
                class="thumbnail_14"
                referrerpolicy="no-referrer"
                src="https://lanhu.oss-cn-beijing.aliyuncs.com/psygwum2arc4gamsw38urir73kn4beypvvcbe5b23a-3589-42e8-b885-68b21d954b4b"
              />
            </div>
            <img
              class="label_2"
              referrerpolicy="no-referrer"
              src="https://lanhu.oss-cn-beijing.aliyuncs.com/ps6vhl82k32r6h87sgbz4wwmvbxmp7wqme24a084c-be01-4de2-a103-f390c71e6af5"
            />
            <div class="section_3 flex-col">
              <div class="text-wrapper_3 flex-col">
                <span class="text_16">下载</span>
              </div>
            </div> -->
          </div>
          <div class="group_10 flex-row justify-center">
            <div id="video-container0" style="width: 447px; height: 356px"></div>
<!--            <div class="player_1 flex-col justify-end"></div>-->
<!--            <div class="section_5 flex-col">-->
<!--              <span class="text_19"-->
<!--                >2022年03月30日&nbsp;&nbsp;&nbsp;星期三&nbsp;&nbsp;11：31：35</span-->
<!--              >-->
<!--              <div class="group_11 flex-row">-->
<!--                <span class="text_20">监控画面</span>-->
<!--                <div class="image-wrapper_5 flex-col">-->
<!--                  <img-->
<!--                    class="thumbnail_15"-->
<!--                    referrerpolicy="no-referrer"-->
<!--                    src="https://lanhu.oss-cn-beijing.aliyuncs.com/psowlxq9qxiimd44h3fu9udwbpdk35n2xoo7a07b96a-347b-461a-9832-5bfe3f436196"-->
<!--                  />-->
<!--                </div>-->
<!--              </div>-->
<!--            </div>-->
          </div>
          <div class="group_10 flex-row justify-between">
            <div id="video-container1" style="width: 447px; height: 356px"></div>
            <div id="video-container2" style="width: 447px; height: 356px"></div>
<!--            <div class="section_4 flex-col justify-end">-->
<!--              <span class="text_17"-->
<!--                >2022年03月30日&nbsp;&nbsp;&nbsp;星期三&nbsp;&nbsp;11：31：35</span-->
<!--              >-->
<!--              <div class="box_8 flex-row">-->
<!--                <span class="text_18">前方画面</span>-->
<!--                <img-->
<!--                  class="label_3"-->
<!--                  referrerpolicy="no-referrer"-->
<!--                  src="https://lanhu.oss-cn-beijing.aliyuncs.com/pso4o6hh4wlsh18fu9vnr74n4l9j9wzafoxcdfb0f4f-3015-4964-8f87-c0c7135d466b"-->
<!--                />-->
<!--              </div>-->
<!--            </div>-->
<!--            <div class="section_5 flex-col">-->
<!--              <span class="text_19"-->
<!--                >2022年03月30日&nbsp;&nbsp;&nbsp;星期三&nbsp;&nbsp;11：31：35</span-->
<!--              >-->
<!--              <div class="group_11 flex-row">-->
<!--                <span class="text_20">监控画面</span>-->
<!--                <div class="image-wrapper_5 flex-col">-->
<!--                  <img-->
<!--                    class="thumbnail_15"-->
<!--                    referrerpolicy="no-referrer"-->
<!--                    src="https://lanhu.oss-cn-beijing.aliyuncs.com/psowlxq9qxiimd44h3fu9udwbpdk35n2xoo7a07b96a-347b-461a-9832-5bfe3f436196"-->
<!--                  />-->
<!--                </div>-->
<!--              </div>-->
<!--            </div>-->
          </div>
        </div>
      </div>
<!--      <div class="image-wrapper_6 flex-col">-->
<!--        <img-->
<!--          class="label_4"-->
<!--          referrerpolicy="no-referrer"-->
<!--          src="https://lanhu.oss-cn-beijing.aliyuncs.com/psp6d5rfoa3upk47uaszkh9fkgn8e0tk837749eb-c282-4c30-b38c-32fb678ac6aa"-->
<!--        />-->
<!--      </div>-->
      <canvas
        ref="canvasPoint"
        class="image_100"
        :style="{
              backgroundImage: `url(${mapImageSrc})`,
            }"
        :width="895"
        height="722"
      ></canvas>
    </div>
  </div>
</template>
<script>
import {get} from "@/util/axios";

var that;
var interval1;
// import EZUIKit from "ezuikit-js";
import EZUIKit from '@/assets/js/ezuikit';
export default {
  data() {
    return {
      robotId: 0,
      startTime: "",//进入页面时间
      mapImageSrc: "",
      xbi: null,
      ybi: null,
      robotPointAdr: [],
      intervalId: null,// 用于后续可能会控制轨迹
      videoList3: [],
      player0:null,
      player1:null,
      player2:null,
      y1: "",
      y2: "",
      selectedOption: 1,
    };
  },
  mounted() {
    that = this;
    that.cacheImages();
    that.getThreeMap2();
    this.intervalId = setInterval(function () {
      that.getThreeMovePoint();
    }, 5000);
    interval1 = setInterval(function () {
      that.getTime();
    }, 1000);
    that.playVideo3();
  },
  created() {
    if (this.$route.query.robotId) {
      this.robotId = this.$route.query.robotId;
    }
    this.startTime=Date.now();
  },
  beforeDestroy() {
    // 在组件销毁前销毁播放器
    if (this.player0) {
      // 销毁播放器实例
      this.player0.destroy();
      // 解除播放器的引用
      this.player0 = null;
    }
    if (this.player1) {
      // 销毁播放器实例
      this.player1.destroy();
      // 解除播放器的引用
      this.player1 = null;
    }
    if (this.player2) {
      // 销毁播放器实例
      this.player2.destroy();
      // 解除播放器的引用
      this.player2 = null;
    }
    // 清除所有定时器
    if (this.intervalId) {
      clearInterval(this.intervalId);
      this.intervalId = null;
    }
    if (interval1) {
      clearInterval(interval1);
      interval1 = null;
    }
  },
  methods: {
    cacheImages(){
      console.log("照片初始化");
      // 图片 URLs
      const imageUrls = [
        "https://lanhu.oss-cn-beijing.aliyuncs.com/psv0r3wjvjk984k3qbwu48xn8qzve39p49i19742a27-d153-4c41-a85b-d2076ff5c6de",
        "https://lanhu.oss-cn-beijing.aliyuncs.com/psy4n1b0hjqp67i545ycbfx1npn8zyvoct377fee27-f911-44b1-8e3d-02076bad299a",
        "https://lanhu.oss-cn-beijing.aliyuncs.com/pslzswcz8juu9wz4i9ytqdzrt8f6asg46a53e87f34-6187-430e-a09a-3f02f1d32032",
        "https://lanhu.oss-cn-beijing.aliyuncs.com/ps3v4gmwwa7yxq9382xukyp87afyc1rcn0ed91ab118-0367-4b14-84c9-7deec144e99a",
        "https://lanhu.oss-cn-beijing.aliyuncs.com/psnwiagczw6qkgkih246ylevbyz2lzi3m17f4c10b-cf08-4341-8ba7-352c9aa8b904",
        "https://lanhu.oss-cn-beijing.aliyuncs.com/psez36ntc9eyududdabc0hvt3b7yw6gmeft172efb90-2d2e-4c37-bc2d-6dfef15f4fbe",
        "https://lanhu.oss-cn-beijing.aliyuncs.com/psi0s1cho7yxubjdkfuch7rv1ul3nidvr6311c67d-3628-4dc4-8983-2184a53ae7fa",
        "https://lanhu.oss-cn-beijing.aliyuncs.com/pskk8slngx8jflgt9vy3n14fc1o2hsfwn5t85cb9595-f068-413b-8524-961530cd6931",
        "https://lanhu.oss-cn-beijing.aliyuncs.com/psnsw3wyqk23fv24yhnegbwamtdzey6i4lm881fab8d-8ad4-4b7e-bded-824b122bbb78",
        "https://lanhu.oss-cn-beijing.aliyuncs.com/psk5xn3sq0xornyrs8b1mk9dw64qtuyexjce111664-f0e6-44ae-938d-7583c625b617",
        "https://lanhu.oss-cn-beijing.aliyuncs.com/psbfgqud2srt93f2s513gtjl27f9y9vzoba630f47ba-5652-4445-84c1-7bcdf1445601",
        "https://lanhu.oss-cn-beijing.aliyuncs.com/psu374b8xusg0w6yk3mbpcb6s9g81c0shu61403602-9173-4a64-8cfd-66b787a42b34",
        // 更多图片 URL
      ];

      // 逐一加载图片并设置 referrerPolicy
      imageUrls.forEach((url) => {
        const img = new Image();
        img.src = url;
        img.referrerPolicy = "no-referrer";  // 加上 referrer-policy
      });
    },
    getThreeMap2() {
      console.log("加载地图");
      get("/threeBigscreen/getThreeMap", {
        robotId: this.robotId,
      }).then((res) => {
        this.mapImageSrc = res.data.mapUrl;
        this.ybi=(res.data.mapY / 722);
        this.xbi=(res.data.mapX / 895);
      });
    },
    getThreeMovePoint() {
      that = this;
      console.log("加载行走路线");
      get("/threeBigscreen/getThreeMovePointByTime", {
        robotId: this.robotId,
        startTime: this.startTime,
      }).then((res) => {
        this.robotPointAdr = res.data.pointList;

        const newXunipoint = this.robotPointAdr.map((point) => ({
          pointX: ((parseFloat(point.pointX)*20.01223990208078+305) / that.xbi),
          pointY: ((1846-parseFloat(point.pointY)*20.00797925393976) / that.ybi),
          pointYaw:parseFloat(point.pointYaw),
        }));

        const canvas = that.$refs.canvasPoint;
        const ctx = canvas.getContext("2d");
        ctx.clearRect(0, 0, canvas.width, canvas.height);

        const points = newXunipoint;
        ctx.beginPath();
        const arrowWidth = 5;
        ctx.moveTo(points[0].pointX, points[0].pointY);

        for (let i = 1; i < points.length; i++) {
          ctx.lineTo(points[i].pointX, points[i].pointY);
        }

        ctx.lineWidth = 1;
        ctx.strokeStyle = "red";
        // ctx.lineTo(-arrowWidth, -arrowWidth);
        // ctx.lineTo(-arrowWidth, arrowWidth);
        // ctx.lineTo(0, 0);
        // ctx.lineTo(0, -arrowWidth);

        ctx.stroke();

        const lastPoint = points[points.length - 1];
        const lastX = lastPoint.pointX;
        const lastY = lastPoint.pointY;
        const yaw = lastPoint.pointYaw;

        const img = new Image();
        // img.src = "https://lanhu.oss-cn-beijing.aliyuncs.com/psp6d5rfoa3upk47uaszkh9fkgn8e0tk837749eb-c282-4c30-b38c-32fb678ac6aa";
        // img.referrerPolicy = 'no-referrer';
        img.src = require('@/assets/location.png');
        img.onload = function() {
          // 图片的尺寸设置为你需要的宽度和高度，这里我设定为50x50
          const imgWidth = 22;
          const imgHeight = 22;

          // 保存当前画布状态
          ctx.save();
          // 设置旋转中心为图片的中心
          ctx.translate(lastX, lastY); // 将坐标系移动到图片的中心
          ctx.rotate(2*Math.PI-yaw); // 旋转角度，转换为弧度
          // 绘制图片，使用图片的中心坐标
          ctx.drawImage(img, -imgWidth / 2, -imgHeight / 2, imgWidth, imgHeight);
          // 恢复画布状态
          ctx.restore();
          // ctx.drawImage(img, lastX - imgWidth / 2, lastY - imgHeight / 2, imgWidth, imgHeight);
        }
      });
    },
    playVideo3() {
      get("/threeBigscreen/getLive/" + this.robotId, {}).then((res) => {
        this.videoList3 = res.data;
        this.player0 = new EZUIKit.EZUIKitPlayer({
          id: "video-container0", // 视频容器ID
          accessToken: this.videoList3[0].accessToken,
          url: this.videoList3[0].url,
          template: "pcLive",
          width: 447,
          height: 356,
          quality: 0,
        });
        this.player1 = new EZUIKit.EZUIKitPlayer({
          id: "video-container1", // 视频容器ID
          accessToken: this.videoList3[1].accessToken,
          url: this.videoList3[1].url,
          template: "pcLive",
          width: 447,
          height: 356,
          quality: 0,
        });
        this.player2 = new EZUIKit.EZUIKitPlayer({
          id: "video-container2", // 视频容器ID
          accessToken: this.videoList3[2].accessToken,
          url: this.videoList3[2].url,
          template: "pcLive",
          width: 447,
          height: 356,
          quality: 0,
        });
      });
    },
    handleSelectChange() {
      console.log(this.selectedOption);
      // 清除旧的定时器
      clearInterval(this.intervalId);
      // 根据选项值来改变定时器间隔
      let interval = this.selectedOption === "1" ? 5000 : 1000;
      // 重新设置定时器
      this.intervalId = setInterval(() => {
        this.getThreeMovePoint();
      }, interval);
    },
    getTime() {
      var date = new Date();
      var year = date.getFullYear();
      var mon = date.getMonth() + 1;
      var da = date.getDate(); //获取当前日

      var day = date.getDay();
      var h = date.getHours();
      var m = date.getMinutes();
      var s = date.getSeconds();
      var submitTime = "";
      submitTime += year + "-";
      if (mon >= 10) {
        // submitTime += mon + "-";
      } else {
        mon = "0" + mon;
      }
      if (da >= 10) {
        // submitTime += day;
      } else {
        da = "0" + da;
      }
      submitTime += " ";
      if (h >= 10) {
        // submitTime += h + ":";
      } else {
        h = "0" + h;
      }
      if (m >= 10) {
        // submitTime += m;
      } else {
        m = "0" + m;
      }
      if (s < 10) {
        s = "0" + s;
      }
      var weeks = new Array(
        "星期日",
        "星期一",
        "星期二",
        "星期三",
        "星期四",
        "星期五",
        "星期六"
      );
      this.y1 = year + "年" + mon + "月" + da + "日";
      this.y2 = weeks[day] + " " + h + ":" + m + ":" + s;
    },
  },
};
</script>
<style  lang="scss" scoped>
body * {
  box-sizing: border-box;
  flex-shrink: 0;
}
body {
  font-family: PingFangSC-Regular, Roboto, Helvetica Neue, Helvetica, Tahoma,
    Arial, PingFang SC-Light, Microsoft YaHei;
}
input {
  background-color: transparent;
  border: 0;
}
button {
  margin: 0;
  padding: 0;
  border: 1px solid transparent;
  outline: none;
  background-color: transparent;
}

button:active {
  opacity: 0.6;
}
.van-nav-bar__left:active,
.van-nav-bar__right:active {
  opacity: 1;
}
[class*="van-"]::after {
  border-bottom: 0;
}
.flex-col {
  display: flex;
  flex-direction: column;
}
.flex-row {
  display: flex;
  flex-direction: row;
}
.justify-start {
  display: flex;
  justify-content: flex-start;
}
.justify-center {
  display: flex;
  justify-content: center;
}

.justify-end {
  display: flex;
  justify-content: flex-end;
}
.justify-evenly {
  display: flex;
  justify-content: space-evenly;
}
.justify-around {
  display: flex;
  justify-content: space-around;
}
.justify-between {
  display: flex;
  justify-content: space-between;
}
.align-start {
  display: flex;
  align-items: flex-start;
}
.align-center {
  display: flex;
  align-items: center;
}
.align-end {
  display: flex;
  align-items: flex-end;
}

.page {
  position: relative;
  width: 100%;

  overflow: hidden;
}

.section_1 {
  position: relative;
  width: 100%;
  height: 100%;
  background: url(https://lanhu.oss-cn-beijing.aliyuncs.com/psv0r3wjvjk984k3qbwu48xn8qzve39p49i19742a27-d153-4c41-a85b-d2076ff5c6de)
    100% no-repeat;
  background-size: 100% 100%;
}

.box_1 {
  width: 98%;
  height: 90px;
  margin: 2px 0 0 31px;
}

.group_1 {
  width: 350px;
  height: 43px;
  margin-top: 38px;
}

.image_1 {
  width: 1900px;
  height: 94px;
}

.text-wrapper_1 {
  width: 339px;
  height: 19px;
  margin: 21px 0 0 11px;
}

.text_1 {
  width: 146px;
  height: 19px;
  overflow-wrap: break-word;
  color: rgba(254, 254, 255, 1);
  font-size: 20px;
  font-family: SourceHanSansSC-Regular;
  font-weight: normal;
  text-align: left;
  white-space: nowrap;
  line-height: 26px;
}

.text_2 {
  width: 177px;
  height: 19px;
  overflow-wrap: break-word;
  color: rgba(254, 254, 255, 1);
  font-size: 20px;
  font-family: SourceHanSansSC-Regular;
  font-weight: normal;
  text-align: left;
  white-space: nowrap;
  line-height: 26px;
}

.text-wrapper_2 {
  height: 90px;
  background: url(https://lanhu.oss-cn-beijing.aliyuncs.com/psilecedkp9ferkcu95p1eb17lne1lpzlmc0187a0e-901b-41f3-91a9-b06789427e65) -6px -6px
    no-repeat;
  background-size: 1345px 103px;
  margin-left: -55px;
  width: 1332px;
}

.text_3 {
  text-shadow: 0px 0px 13px rgba(23, 125, 230, 0.38);
  width: 704px;
  height: 51px;
  overflow-wrap: break-word;
  color: rgba(255, 255, 255, 1);
  font-size: 70px;
  font-family: YouSheBiaoTiHei;
  font-weight: normal;
  text-align: center;
  white-space: nowrap;
  line-height: 70px;
  margin: 20px 0 0 310px;
}

.image_2 {
  width: 82px;
  height: 41px;
  margin: 16px 0 0 8px;
}

.text_4 {
  width: 170px;
  height: 34px;
  overflow-wrap: break-word;
  color: rgba(13, 204, 255, 1);
  font-size: 46px;
  font-family: PangMenZhengDao;
  font-weight: normal;
  text-align: left;
  white-space: nowrap;
  line-height: 46px;
  margin: 22px 0 0 0px;
}

.box_2 {
  width: 762px;
  height: 38px;
  margin: 35px 0 0 580px;
}

.block_1 {
  height: 38px;
  background: url(https://lanhu.oss-cn-beijing.aliyuncs.com/psez36ntc9eyududdabc0hvt3b7yw6gmeft172efb90-2d2e-4c37-bc2d-6dfef15f4fbe) -6px -6px
    no-repeat;
  background-size: 363px 49px;
  width: 351px;
}

.block_2 {
  height: 38px;
  background: url(https://lanhu.oss-cn-beijing.aliyuncs.com/psnsw3wyqk23fv24yhnegbwamtdzey6i4lm881fab8d-8ad4-4b7e-bded-824b122bbb78)
    0px 0px no-repeat;
  background-size: 352px 38px;
  width: 351px;
  position: relative;
}

.text_5 {
  width: 139px;
  height: 20px;
  overflow-wrap: break-word;
  color: rgba(0, 255, 246, 1);
  font-size: 20px;
  font-family: SourceHanSansSC-Bold;
  font-weight: 700;
  text-align: left;
  white-space: nowrap;
  line-height: 20px;
  margin: 8px 0 0 96px;
}

.thumbnail_1 {
  position: absolute;
  left: -2px;
  top: 9px;
  width: 5px;
  height: 4px;
}

.thumbnail_2 {
  position: absolute;
  left: 348px;
  top: 9px;
  width: 5px;
  height: 4px;
}

.thumbnail_3 {
  position: absolute;
  left: -2px;
  top: 24px;
  width: 5px;
  height: 4px;
}

.thumbnail_4 {
  position: absolute;
  left: 348px;
  top: 24px;
  width: 5px;
  height: 4px;
}

.block_3 {
  height: 38px;
  background: url(https://lanhu.oss-cn-beijing.aliyuncs.com/ps3v4gmwwa7yxq9382xukyp87afyc1rcn0ed91ab118-0367-4b14-84c9-7deec144e99a) -6px -6px
    no-repeat;
  background-size: 363px 49px;
  width: 351px;
}

.box_3 {
  height: 38px;
  background: url(https://lanhu.oss-cn-beijing.aliyuncs.com/psnwiagczw6qkgkih246ylevbyz2lzi3m17f4c10b-cf08-4341-8ba7-352c9aa8b904)
    0px 0px no-repeat;
  background-size: 352px 38px;
  width: 351px;
  position: relative;
}

.text_6 {
  width: 179px;
  height: 20px;
  overflow-wrap: break-word;
  color: rgba(0, 255, 246, 1);
  font-size: 20px;
  font-family: SourceHanSansSC-Bold;
  font-weight: 700;
  text-align: left;
  white-space: nowrap;
  line-height: 20px;
  margin: 8px 0 0 86px;
}

.thumbnail_5 {
  position: absolute;
  left: -2px;
  top: 9px;
  width: 5px;
  height: 4px;
}

.thumbnail_6 {
  position: absolute;
  left: 348px;
  top: 9px;
  width: 5px;
  height: 4px;
}

.thumbnail_7 {
  position: absolute;
  left: -2px;
  top: 24px;
  width: 5px;
  height: 4px;
}

.thumbnail_8 {
  position: absolute;
  left: 348px;
  top: 24px;
  width: 5px;
  height: 4px;
}

.box_4 {
  width: 902px;
  height: 356px;
  margin: 518px 0 41px 1021px;
}

.group_2 {
  width: 447px;
  height: 356px;
  background: url(https://lanhu-dds-backend.oss-cn-beijing.aliyuncs.com/merge_image/imgs/6354ea729010442987a9cb6f2d8632c6_mergeImage.png)
    100% no-repeat;
  background-size: 100% 100%;
}

.text_7 {
  width: 257px;
  height: 15px;
  overflow-wrap: break-word;
  color: rgba(255, 255, 255, 1);
  font-size: 15px;
  font-family: SourceHanSansSC-Regular;
  font-weight: normal;
  text-align: left;
  white-space: nowrap;
  line-height: 15px;
  margin: 14px 0 0 11px;
}

.group_3 {
  width: 447px;
  height: 69px;
  background: url(https://lanhu.oss-cn-beijing.aliyuncs.com/psx1u53ridwkdbfoc2a26sqdi9ykp85vj5cda8019c-f7c3-4076-9535-dbbac7b4a312)
    100% no-repeat;
  background-size: 100% 100%;
  margin: 259px 0 1px 1px;
}

.text_8 {
  width: 63px;
  height: 15px;
  overflow-wrap: break-word;
  color: rgba(255, 255, 255, 1);
  font-size: 16px;
  font-family: SourceHanSansSC-Regular;
  font-weight: normal;
  text-align: left;
  white-space: nowrap;
  line-height: 16px;
  margin: 46px 0 0 14px;
}

.image-wrapper_1 {
  height: 23px;
  background: url(https://lanhu.oss-cn-beijing.aliyuncs.com/psjta29elmbzgoh2cilk3knsgo0wz3vrk7d760d3d-afd4-4d9c-bc6a-11007603f8de) -1px -1px
    no-repeat;
  background-size: 24px 24px;
  width: 23px;
  margin: 39px 8px 0 339px;
}

.thumbnail_9 {
  width: 13px;
  height: 13px;
  margin: 5px 0 0 5px;
}

.group_4 {
  width: 447px;
  height: 356px;
  background: url(https://lanhu-dds-backend.oss-cn-beijing.aliyuncs.com/merge_image/imgs/159ac1e55df446df90896ae9b239bf9e_mergeImage.png)
    100% no-repeat;
  background-size: 100% 100%;
}

.text_9 {
  width: 257px;
  height: 15px;
  overflow-wrap: break-word;
  color: rgba(255, 255, 255, 1);
  font-size: 15px;
  font-family: SourceHanSansSC-Regular;
  font-weight: normal;
  text-align: left;
  white-space: nowrap;
  line-height: 15px;
  margin: 14px 0 0 16px;
}

.block_4 {
  width: 447px;
  height: 51px;
  background: url(https://lanhu.oss-cn-beijing.aliyuncs.com/ps8go71vk161k4yx5mwku73ic3c75yrn0gec03b051-8cff-44cf-a097-a5afd5c52cc7)
    100% no-repeat;
  background-size: 100% 100%;
  margin: 277px 0 1px 0;
}

.text_10 {
  width: 63px;
  height: 16px;
  overflow-wrap: break-word;
  color: rgba(255, 255, 255, 1);
  font-size: 16px;
  font-family: SourceHanSansSC-Regular;
  font-weight: normal;
  text-align: left;
  white-space: nowrap;
  line-height: 16px;
  margin: 28px 0 0 14px;
}

.image-wrapper_2 {
  height: 23px;
  background: url(https://lanhu.oss-cn-beijing.aliyuncs.com/psbv17ecqhww62cxs41ibkoc12g9ux0wl1ka02638b2-eb68-4d51-b7db-b33fd47db10b) -1px -1px
    no-repeat;
  background-size: 24px 24px;
  width: 23px;
  margin: 21px 8px 0 339px;
}

.thumbnail_10 {
  width: 13px;
  height: 13px;
  margin: 5px 0 0 5px;
}

.box_5 {
  position: absolute;
  left: 25px;
  top: 186px;
  width: 1870px;
  height: 620px;
}

.group_5 {
  width: 930px;
  height: 620px;
  background: url(https://lanhu.oss-cn-beijing.aliyuncs.com/pslzswcz8juu9wz4i9ytqdzrt8f6asg46a53e87f34-6187-430e-a09a-3f02f1d32032)
    100% no-repeat;
  background-size: 100% 100%;
}

.box_6 {
  width: 213px;
  height: 26px;
  margin: 19px 0 0 19px;
}

.image-wrapper_3 {
  height: 15px;
  background: url(https://lanhu.oss-cn-beijing.aliyuncs.com/pskk8slngx8jflgt9vy3n14fc1o2hsfwn5t85cb9595-f068-413b-8524-961530cd6931)
    100% no-repeat;
  background-size: 100% 100%;
  margin-top: 5px;
  width: 14px;
}

.thumbnail_11 {
  width: 14px;
  height: 15px;
}

.text_11 {
  width: 180px;
  height: 26px;
  overflow-wrap: break-word;
  color: rgba(255, 255, 255, 1);
  font-size: 26px;
  font-family: SourceHanSansSC-Bold;
  font-weight: 700;
  text-align: left;
  white-space: nowrap;
  line-height: 26px;
}

.box_7 {
  width: 218px;
  height: 41px;
  margin: 23px 0 511px 20px;
}

.text_12 {
  width: 79px;
  height: 20px;
  overflow-wrap: break-word;
  color: rgba(255, 255, 255, 1);
  font-size: 20px;
  font-family: SourceHanSansSC-Bold;
  font-weight: 700;
  text-align: left;
  white-space: nowrap;
  line-height: 20px;
  margin-top: 10px;
}

.group_6 {
  width: 123px;
  height: 41px;
  background: url(https://lanhu.oss-cn-beijing.aliyuncs.com/ps2ampciibxmgj6iqm2zrrmqo7ww53lo957005db0-0b9a-4db1-a931-09c5861cb2d3) -1px
    0px no-repeat;
  background-size: 125px 41px;
}

.text_13 {
  width: 54px;
  height: 17px;
  overflow-wrap: break-word;
  color: rgba(87, 246, 255, 1);
  font-size: 18px;
  font-family: SourceHanSansSC-Bold;
  font-weight: 700;
  text-align: left;
  white-space: nowrap;
  line-height: 18px;
  margin: 12px 0 0 18px;
}

.thumbnail_12 {
  width: 16px;
  height: 10px;
  margin: 16px 19px 0 16px;
}

.group_7 {
  width: 930px;
  height: 620px;
  background: url(https://lanhu.oss-cn-beijing.aliyuncs.com/psy4n1b0hjqp67i545ycbfx1npn8zyvoct377fee27-f911-44b1-8e3d-02076bad299a)
    100% no-repeat;
  background-size: 100% 100%;
}

.group_8 {
  width: 237px;
  height: 25px;
  margin: 20px 0 0 30px;
}

.image-wrapper_4 {
  height: 15px;
  background: url(https://lanhu.oss-cn-beijing.aliyuncs.com/psi0s1cho7yxubjdkfuch7rv1ul3nidvr6311c67d-3628-4dc4-8983-2184a53ae7fa)
    100% no-repeat;
  background-size: 100% 100%;
  margin-top: 4px;
  width: 14px;
}

.thumbnail_13 {
  width: 14px;
  height: 15px;
}

.text_14 {
  width: 213px;
  height: 25px;
  overflow-wrap: break-word;
  color: rgba(255, 255, 255, 1);
  font-size: 26px;
  font-family: SourceHanSansSC-Bold;
  font-weight: 700;
  text-align: left;
  white-space: nowrap;
  line-height: 26px;
}

.group_9 {
  width: 636px;
  height: 41px;
  margin: 24px 0 0 290px;
}

.label_1 {
  width: 22px;
  height: 21px;
  margin-top: 8px;
}

.section_2 {
  width: 306px;
  height: 41px;
  background: url(https://lanhu.oss-cn-beijing.aliyuncs.com/pstd1ncm4dvwt3h07u7p81l0cgtzcr3pboo916bb3f4-3a08-42f4-84a4-9f02e2b9d8bc) -1px
    0px no-repeat;
  background-size: 307px 41px;
  margin-left: 16px;
}

.text_15 {
  width: 208px;
  height: 15px;
  overflow-wrap: break-word;
  color: rgba(87, 246, 255, 1);
  font-size: 18px;
  font-family: SourceHanSansSC-Bold;
  font-weight: 700;
  text-align: left;
  white-space: nowrap;
  line-height: 18px;
  margin: 13px 0 0 18px;
}

.thumbnail_14 {
  width: 16px;
  height: 10px;
  margin: 16px 8px 0 56px;
}

.label_2 {
  width: 22px;
  height: 21px;
  margin: 14px 0 0 18px;
}

.section_3 {
  height: 40px;
  background: url(https://lanhu.oss-cn-beijing.aliyuncs.com/psj5wwdmnkxyv9e3awiievb0tjw2a04zsyr9acce25e-7517-4d38-9b2b-8fa09da050e2) -4px -4px
    no-repeat;
  background-size: 128px 46px;
  margin-left: 132px;
  width: 120px;
}

.text-wrapper_3 {
  height: 30px;
  background: url(https://lanhu.oss-cn-beijing.aliyuncs.com/psouip10ajxgxsnua7ufculh87m0y31quq0a9bf374-612c-4fd1-b33f-080d6ea7be93) -4px -4px
    no-repeat;
  background-size: 109px 36px;
  width: 101px;
  margin: 5px 0 0 8px;
}

.text_16 {
  text-shadow: 0px -4px 6px rgba(255, 255, 255, 0.56);
  width: 35px;
  height: 17px;
  overflow-wrap: break-word;
  color: rgba(87, 246, 255, 1);
  font-size: 18px;
  font-family: SourceHanSansSC-Regular;
  font-weight: normal;
  text-align: center;
  white-space: nowrap;
  line-height: 18px;
  margin: 6px 0 0 34px;
}

.group_10 {
  width: 902px;
  height: 357px;
  margin: 20px 0 0 23px;
}

.section_4 {
  width: 447px;
  height: 356px;
  background: url(https://lanhu-dds-backend.oss-cn-beijing.aliyuncs.com/merge_image/imgs/cb3bf5cfbe4d49bf863f7b85a088ca31_mergeImage.png)
    100% no-repeat;
  background-size: 100% 100%;
}
.player_1 {
  width: 447px;
  height: 356px;
  border: 1px solid #ffffff;
}
.text_17 {
  width: 257px;
  height: 15px;
  overflow-wrap: break-word;
  color: rgba(255, 255, 255, 1);
  font-size: 15px;
  font-family: SourceHanSansSC-Regular;
  font-weight: normal;
  text-align: left;
  white-space: nowrap;
  line-height: 15px;
  margin: 13px 0 0 18px;
}

.box_8 {
  width: 447px;
  height: 69px;
  background: url(https://lanhu.oss-cn-beijing.aliyuncs.com/psu374b8xusg0w6yk3mbpcb6s9g81c0shu61403602-9173-4a64-8cfd-66b787a42b34)
    100% no-repeat;
  background-size: 100% 100%;
  margin: 259px 0 0 1px;
}

.text_18 {
  width: 63px;
  height: 15px;
  overflow-wrap: break-word;
  color: rgba(255, 255, 255, 1);
  font-size: 16px;
  font-family: SourceHanSansSC-Regular;
  font-weight: normal;
  text-align: left;
  white-space: nowrap;
  line-height: 16px;
  margin: 46px 0 0 14px;
}

.label_3 {
  width: 24px;
  height: 24px;
  margin: 38px 8px 0 338px;
}

.section_5 {
  width: 447px;
  height: 356px;
  background: url(https://lanhu-dds-backend.oss-cn-beijing.aliyuncs.com/merge_image/imgs/903f194c8286452693c96d41372fa2ec_mergeImage.png)
    100% no-repeat;
  background-size: 100% 100%;
  margin-top: 1px;
}

.text_19 {
  width: 257px;
  height: 15px;
  overflow-wrap: break-word;
  color: rgba(11, 11, 11, 1);
  font-size: 15px;
  font-family: SourceHanSansSC-Regular;
  font-weight: normal;
  text-align: left;
  white-space: nowrap;
  line-height: 15px;
  margin: 12px 0 0 27px;
}

.group_11 {
  width: 447px;
  height: 51px;
  background: url(https://lanhu.oss-cn-beijing.aliyuncs.com/psk5xn3sq0xornyrs8b1mk9dw64qtuyexjce111664-f0e6-44ae-938d-7583c625b617)
    100% no-repeat;
  background-size: 100% 100%;
  margin: 277px 0 1px 0;
}

.text_20 {
  width: 63px;
  height: 15px;
  overflow-wrap: break-word;
  color: rgba(255, 255, 255, 1);
  font-size: 16px;
  font-family: SourceHanSansSC-Regular;
  font-weight: normal;
  text-align: left;
  white-space: nowrap;
  line-height: 16px;
  margin: 27px 0 0 14px;
}

.image-wrapper_5 {
  height: 23px;
  background: url(https://lanhu.oss-cn-beijing.aliyuncs.com/psbfgqud2srt93f2s513gtjl27f9y9vzoba630f47ba-5652-4445-84c1-7bcdf1445601) -1px -1px
    no-repeat;
  background-size: 24px 24px;
  width: 23px;
  margin: 21px 8px 0 339px;
}

.thumbnail_15 {
  width: 13px;
  height: 13px;
  margin: 5px 0 0 5px;
}

.image-wrapper_6 {
  height: 722px;
  background: url(https://lanhu-dds-backend.oss-cn-beijing.aliyuncs.com/merge_image/imgs/af088600017b444fb68b22e5128b145f_mergeImage.png)
    100% no-repeat;
  background-size: 100% 100%;
  width: 895px;
  position: absolute;
  left: 44px;
  top: 318px;
}
.image_100 {
  margin: auto;
  background-size: 100% 100%;
  background-repeat: no-repeat;
  width: 895px;
  position: absolute;
  left: 44px;
  top: 318px;
}

.label_4 {
  width: 23px;
  height: 35px;
  margin: 218px 0 0 375px;
}
.text-wrapper_01 {
  width: 330px;
  height: 19px;
  margin: -30px 0 10px 11px;
  /* border: 1px solid white; */
}
.text_01 {
  width: 146px;
  height: 19px;
  overflow-wrap: break-word;
  color: rgba(254, 254, 255, 1);
  font-size: 20px;
  font-family: SourceHanSansSC-Regular;
  font-weight: NaN;
  text-align: left;
  white-space: nowrap;
  line-height: 26px;
}
.homeBtn {
  color: #ffffff;
  //   margin: -30px 0 0 0;
  position: absolute;
  left: 1800px;
  top: 80px;
  width: 100px;
  height: 40px;
  background: url("../assets/按钮.png");
  background-size: contain;
  background-repeat: no-repeat;
}
.gaodi {
  width: 150px;
  height: 41px;
  background-color: #1b569b;
  color: rgba(87, 246, 255, 1);
  font-size: 18px;
  border: 2px solid #00fff6;
  border-radius: 2px;
  margin-left: 10px;
}
</style>

